import Index from 'src/index';
import './style/index.scss';
export default Index;
